var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import { Drawer, Modal } from '@mui/material';
import MOIWaiverEligibleInstitutesAdditionalInformation from './MOIWaiverEligibleInstitutesAdditionalInformation';
var MOIWaiverEligibleInstitutesList = function (_a) {
    var waiverData = _a.waiverData, universityName = _a.universityName;
    var _b = __read(React.useState(false), 2), expandWaiverBoardInfo = _b[0], setExpandWaiverBoardInfo = _b[1];
    var _c = __read(React.useState(false), 2), openModal = _c[0], setOpenModal = _c[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(GBTypography, { variant: "link3Regular", className: "lfc-text-primary-500 lfc-hidden lg:lfc-block", onClick: function () {
                setExpandWaiverBoardInfo(true);
            } }, "Check eligible institute list"),
        React.createElement(GBTypography, { variant: "link3Regular", className: "lfc-text-primary-500 lg:lfc-hidden lfc-block", onClick: function () {
                setOpenModal(true);
            } }, "Check eligible institute list"),
        React.createElement(Modal, { open: openModal, onClose: function () {
                setOpenModal(false);
            } },
            React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-justify-between lfc-items-center" },
                React.createElement("div", { className: "lfc-w-[90%] lfc-h-[70%] lfc-bg-white lfc-mx-auto lfc-rounded-lg lfc-overflow-y-auto" },
                    React.createElement(MOIWaiverEligibleInstitutesAdditionalInformation, { onClose: function () {
                            setOpenModal(false);
                        }, waiverInformation: waiverData, universityName: universityName })))),
        React.createElement(Drawer, { anchor: "right", open: expandWaiverBoardInfo, onClose: function () {
                setExpandWaiverBoardInfo(false);
            }, className: "lfc-p-4", sx: {
                '& .MuiDrawer-paper': {
                    width: '40%'
                }
            } },
            React.createElement(MOIWaiverEligibleInstitutesAdditionalInformation, { onClose: function () {
                    setExpandWaiverBoardInfo(false);
                }, waiverInformation: waiverData, universityName: universityName }))));
};
export default MOIWaiverEligibleInstitutesList;
//# sourceMappingURL=MOIWaiverEligibleInstitutesList.js.map